import React from "react";
import styled from "styled-components" ;
import { graphql } from "gatsby";
import breakpoints from "../constants/breakpoints";
import Layout from "../components/layout";
import SEO from "../components/seo";
import { siteColors } from "../constants/colors";
import Monkey from "../components/monkey";
import Dance from "../components/dance";
import EphemeralPoseFreelyBand from "../components/ephemeral-pose-freely-band";
import EphemeralInbetweensBand from "../components/ephemeral-inbetweens-band";
import EphemeralEditBand from "../components/ephemeral-edit-band";

import EphemeralRigWithRulesBand from "../components/ephemeral-rig-with-rules-band";
import FourthBand from "../components/fourthband";
import MonsterBand from "../components/monsterband";
import MainFeatureCards from "../components/mainfeaturecards";
import CallBand from "../components/callband";
import { Band } from "../components/band";
import { EmailLink, ExternalLink, InternalLink } from "../components/sitelinks";


const MainFaqContainer = styled.div`
width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
   font-size: 1.2em;
`;

const FaqHeaderContainer = styled.div`
  width: 100%
  display: flex;
  color:  ${ siteColors.light };
  font-size 2em;
  justify-contents: center;
  align-items: center;
  margin-top: 0em;
`;

const FaqContainer = styled.div`
  margin-top: 1em;
  width: 1080px;
  max-width: 1080px;
  @media (max-width: ${ breakpoints.desktopSD }px) {
  max-width: 720px;
  }
  @media (max-width: ${ breakpoints.iPad }px) {
  max-width: 640px;
  }
  @media (max-width: ${ breakpoints.xLargePhone }px) {
  max-width: 400px;
  }
  background: ${ siteColors.darker };
  color:  ${ siteColors.light };
`;

const SectionHeading = styled.div`
  padding-top: 0.5em;
  padding-bottom: 0.5em;
  padding-left: 2em;
  padding-right: 2em;
  font-size: 1.4em;
`;

const FaqContents = styled.div`
  padding-top: 1.0em;
  padding-bottom: 1em;
  padding-left: 2em;
  padding-right: 2em;
  background: ${ siteColors.darkest };
`;

const FaqItem = styled.div`
  padding-top: 0.5em;
  padding-bottom: 1em;
  padding-left: 2em;
  padding-right: 2em;
  background: ${ siteColors.darkest };
`;

const FaqQuestion = styled.div`
  font-weight: bold;
`;

const FaqAnswer = styled.div`
padding-top: 0.75em;
`;

const IndexPage = (props) => (
  <Layout>
    <SEO title="Home" />
    <Dance />
    <Band rowHeight="2em" columnHeight="3em" background={siteColors.darkest} />
        <EphemeralPoseFreelyBand rowHeight="400px" data={props.data} />
        <EphemeralInbetweensBand background={siteColors.light} />
    <EphemeralEditBand rowHeight="400px"/>
    <EphemeralRigWithRulesBand />
      <MainFaqContainer>
        <FaqHeaderContainer>FAQ</FaqHeaderContainer>
          <FaqContainer>
           <FaqItem>
             <FaqQuestion>
               When will the Ephemeral Animation System be released?
             </FaqQuestion>
            <FaqAnswer>
            We’re aiming to make a beta version available soon, but can’t put a specific date on it yet.
            </FaqAnswer>
          </FaqItem>

        <FaqItem>
        <FaqQuestion>
        What software will the Ephemeral Animation System be available for?
        </FaqQuestion>
        <FaqAnswer>
        We’re currently working on a release for the Unreal Engine. We have plans to release it for other software too, but don’t yet have anything to announce on
    that front.
        </FaqAnswer>
        </FaqItem>

        <FaqItem>
        <FaqQuestion>
        Has the Ephemeral Animation System ever been used in production?
        </FaqQuestion>
        <FaqAnswer>
        An early prototype running in Maya was used for the Emmy-nominated short Little Bird and a series of web videos for FAFSA.
        </FaqAnswer>
        </FaqItem>

    </FaqContainer>
    </MainFaqContainer>

  </Layout>
);


export default IndexPage;

export const pageQuery = graphql`
  query {
    acrobat720: file(relativePath: { eq: "acrobat/acrobat.png" }) {
      childImageSharp {
        fluid(sizes: "(max-width: 604px) 360px, (max-width: 768px) 540px, (max-width: 1506px) and (min-width: 1317px) 540px, 720px",

 srcSetBreakpoints: [360, 540, 720]) {
          ...GatsbyImageSharpFluid
        }
      }
    },
    painting720: file(relativePath: { eq: "paintingScreenshot/paintingScreenshot.png" }) {
      childImageSharp {
        fluid(sizes: "(max-width: 604px) 360px, (max-width: 768px) 540px, (max-width: 1506px) and (min-width: 1317px) 540px, 720px",

 srcSetBreakpoints: [360, 540, 720]) {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`;
